<template>
  <!-- 员工评价-外链页面 -->
  <div class="login-container-box flex-b-r">
    <div class="login-Main-body">
      <p class="firm-clickable" @click="handelPaymentCompleted">支付完成</p>
    </div>
  </div>
</template>

<script>
export default {
  // 组件名称
  name: "E",
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {};
  },
  // 组件初始化
  created() {},
  // 组件实例挂载完毕
  mounted() {},
  //销毁事件
  destroyed() {},
  // 组件方法
  methods: {
    handelPaymentCompleted() {
      this.$router.back();
    },
  },
};
</script>

<style scoped lang="less">
.login-container-box {
  width: 100%;
  height: 100%;
  min-height: 900px;
  min-width: 1100px;
  display: flex;
  flex-direction: column;
}
// 主体
.login-Main-body {
  margin: auto;
  font-size: 14px;
  width: 120px;
  height: 35px;
  line-height: 33px;
  text-align: center;
  border-radius: 5px;
  font-size: 14px;
  box-sizing: border-box;
  border: 1px solid #409eff ;
  cursor: pointer;
  background: #409eff ;
  color: #ffffff;
}
</style>
